import React from "react"
import "./index.scss"

interface LegendProps {
	label: React.ReactNode
	color: string
}

const Legend: React.FC<LegendProps> = ({ label, color }) => (
	<div className="legend-tag">
		<span className="legend-color-box" style={{ background: color }} />
		<p>{label}</p>
	</div>
)
export default Legend
